import React from 'react';
import ReactJson from '@microlink/react-json-view';
import { useQuery } from 'react-admin';
import { spinnerElement } from '@src/components/Common/utils';

/**
 * The team's metadata, read on the same surface a service item's declaration
 * is read on — same viewer, same panel, same controls — because they are the
 * same kind of thing to look at: a document the platform keeps about you.
 *
 * Read-only by the serializer's own account, so there is nothing here but the
 * document.
 */
const MetadataTab = ({
    teamId,
    /**
     * Read a team the caller is not a member of — platform admins only. Without
     * it the endpoint scopes the lookup to the caller's own teams and answers
     * 404, which arrives here as a spinner that never stops.
     */
    allTeams = false,
}: { teamId: number; allTeams?: boolean }) => {
    const { data: team, loaded } = useQuery({
        type: 'getOne',
        resource: 'teams',
        payload: { id: teamId, ...(allTeams ? { filter: { all_teams: true } } : {}) },
    });

    if (!loaded) return <div className="tm-tab">{spinnerElement}</div>;

    const metadata = team?.metadata;
    const isEmpty = !metadata || (typeof metadata === 'object' && Object.keys(metadata).length === 0);

    return (
        <div className="tm-tab">
            {isEmpty ? (
                <div className="tm-empty">No metadata has been recorded for this team.</div>
            ) : (
                <div className="tm-json">
                    <ReactJson
                        style={{ padding: '16px', background: 'transparent' }}
                        src={metadata}
                        displayDataTypes={false}
                        name={null}
                        displayArrayKey={false}
                        displayObjectSize={false}
                    />
                </div>
            )}
        </div>
    );
};

export default MetadataTab;
